/**
 * App route patterns in react-router format (`:id` placeholders).
 * Use directly for static paths and `<Route path>` definitions; pass the
 * `:param` ones through `generatePath(pattern, params)` to navigate.
 */
export const routes = {
  home: "/",
  tests: {
    root: "/tests",
    new: "/tests/new",
    bulkInput: "/tests/wc/bulk-input",
    detail: "/tests/:id",
  },
  processingTests: {
    root: "/processing-tests",
    detail: "/processing-tests/:id",
  },
  accessManagement: "/accessmanagement",
  ags: {
    root: "/ags",
    project: "/ags/:projectId",
  },
} as const;

/** Every leaf string value in `routes`, recursively inferred from the `as const` definition. */
type RoutePathOf<T> = T extends string ? T : { [K in keyof T]: RoutePathOf<T[K]> }[keyof T];

export type RoutePath = RoutePathOf<typeof routes>;

export interface RouteConfig {
  /** Render the page flush against the app shell, without the default root padding. */
  noPadding?: boolean;
}

/** Per-route configuration, keyed by a route pattern (e.g. `routeConfig[routes.tests.bulkInput]`). */
export const routeConfig: Partial<Record<RoutePath, RouteConfig>> = {
  [routes.tests.bulkInput]: { noPadding: true },
};
